import React from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';
//
const Wrap = styled.div`
  align-items: center;
  background-color: lightblue;
  display: flex;
  justify-content: center;
  padding: 2rem;
  width: 100%;
`;
//
export default props => {
  // const { url } = props;

  return <Wrap>Giphy disabled for now.</Wrap>;
};
